export const itemSharing = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'primary',
      text: 'NEW'
    }
  },
  {
    title: true,
    name: 'Sharing',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: 'SubMenu1',
    url: '/header1/subMenu1',
    icon: 'icon-drop'
  },
  {
    name: 'SubMenu2',
    url: '/header1/subMenu1',
    icon: 'icon-puzzle'
  },
  {
    name: 'SubMenu3',
    url: '/header1/subMenu1',
    icon: 'icon-pie-chart'
  },
  {
    name: 'SubMenu4',
    url: '/header1/subMenu1',
    icon: 'icon-star'
  }
];
